import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { ConfigService } from 'src/app/services/config.service';
import { AnalyticsService } from 'src/app/services/analytics.service';

@Component({
  selector: 'app-accept-terms-and-conditions',
  templateUrl: './accept-terms-and-conditions.page.html',
  styleUrls: ['./accept-terms-and-conditions.page.scss'],
})
export class AcceptTermsAndConditionsPage implements OnInit {
  terms: string;

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    public configService: ConfigService,
    private analyticsService: AnalyticsService
   ) {
    this.analyticsService.AnalyticsServiceModalView('accept-terms-and-conditions');
    this.terms = navParams.get('terms');
    console.log('terms', this.terms)
   }

  ngOnInit() {
  }

    accept() {
      this.modalController.dismiss({ accepted: true });
    }
  
    cancel() {
      this.modalController.dismiss({ accepted: false });
    }

      

}
